'use strict'
module.exports = {
  NODE_ENV: '"production"',
  BASE_API: 'http://q0ntn6crhp.51http.tech'
}



// WEBPACK FOOTER //
// ./config/prod.env.js